import { Ref, ref } from 'vue';

export default function useLoading(initialState: boolean = true): { isLoading: Ref<boolean, boolean>, setLoading: (value: boolean) => void } {
    const isLoading = ref<boolean>(initialState);
    function setLoading(value: boolean): void {
        isLoading.value = value;
    }

    return {
        isLoading,
        setLoading: setLoading,
    };
}
